import(/* webpackMode: "eager" */ "/app/src/app/finance/wallets/page.tsx");
